import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import HistoricalVisitService from "../../../services/HistoricalVisitService";
import FileManagerService from "../../../services/FileManagerService";

const ReadOnlyFieldRow = ({ label, value, multiline }) => {
  const displayValue = value != null && String(value).trim() !== "" ? value : "—";

  return (
    <div className="col-sm-12">
          <div className="form-group row">
        <label className="col-sm-3 col-form-label opacity-75">{label}</label>
        <div className="col-sm-9">
          {multiline ? (
            <textarea
              className="form-control form-control-solid"
              readOnly
              rows={4}
              value={displayValue}
            />
          ) : (
            <input
              type="text"
              className="form-control form-control-solid"
              readOnly
              value={displayValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const HistoricalVisitRecordViewModal = ({
  isOpen,
  onClose,
  employeeId,
  recordId,
  Loader,
  Toast,
}) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !employeeId || !recordId) {
      setDetail(null);
      return;
    }
    loadDetail();
  }, [isOpen, employeeId, recordId]);

  const loadDetail = async () => {
    try {
      if (Loader) Loader(true);
      setLoading(true);
      const data = await HistoricalVisitService.getHistoricalVisitRecord(employeeId, recordId);
      setDetail(data);
    } catch (err) {
      if (Toast) Toast.error("Unable to load visit details.");
      onClose();
    } finally {
      setLoading(false);
      if (Loader) Loader(false);
    }
  };

  const viewPdf = () => {
    if (!detail?.file_id) {
      if (Toast) Toast.error("PDF file is not available.");
      return;
    }
    FileManagerService.downloadFile(detail.file_id, "openNewTab");
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="xl"
      dialogClassName="hResponsive"
      contentClassName="h-100"
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <div className="sh_modalBox">
        <Modal.Header closeButton className="p-2">
          <div className="tabs-wrapper w-100">
            <ul className="nav nav-borders nav-tabs border-0" role="tablist">
              <li>
                <a href="#!" className="nav-link active cursor-pointer">
                  Historical Visit Details
                </a>
              </li>
            </ul>
            {/* {detail?.source_filename ? (
              <p className="text-sm text-muted mb-0 mt-1 px-1">{detail.source_filename}</p>
            ) : null} */}
          </div>
          {detail?.file_id ? (
            <div className="d-flex justify-content-end align-items-center flex-shrink-0 ms-2">
              <button type="button" className="btn btn-primary" onClick={viewPdf}>
                View PDF
              </button>
            </div>
          ) : null}
        </Modal.Header>
        <Modal.Body style={{ background: "#eef2f8" }}>
          {loading ? (
            <p className="text-muted text-center py-4 mb-0">Loading visit details…</p>
          ) : (
            <div className="card-body tab-content p-0">
              <div className="tab-pane show active">
                {(detail?.sections || []).map((section, secIndex) => (
                  <div className="card mb-2" key={section.title}>
                    <a
                      href={`#historicalVisitSection_${secIndex}`}
                      className="d-block sh_accordionheader card-header"
                      data-bs-toggle="collapse"
                      role="button"
                      aria-expanded="true"
                      aria-controls={`historicalVisitSection_${secIndex}`}
                      style={{ position: "sticky", top: "-20px", zIndex: 1 }}
                    >
                      <h6 className="mb-0 text-md">{section.title}</h6>
                    </a>
                    <div
                      className="collapse show"
                      id={`historicalVisitSection_${secIndex}`}
                    >
                      <div className="card-body">
                        <div className="row">
                          {(section.fields || []).map((field) => (
                            <ReadOnlyFieldRow
                              key={`${section.title}-${field.label}`}
                              label={field.label}
                              value={field.value}
                              multiline={field.multiline}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {(!detail?.sections || detail.sections.length === 0) && (
                  <p className="text-muted text-center py-4 mb-0">
                    No extracted fields stored for this visit.
                  </p>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <div className="d-flex justify-content-center modal-footer">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default HistoricalVisitRecordViewModal;
